export default __webpack_public_path__ + "static/media/activespiderweb4big.27640b13.png";